import { render, staticRenderFns } from "./editActivity.vue?vue&type=template&id=64a0fa46&"
import script from "./editActivity.vue?vue&type=script&lang=js&"
export * from "./editActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports